/* FlexyMinds cart: drawer position, remove buttons, quick add from "You may also like", paged sliders.
   Quantity changes and rebuilding stay in theme.CartForm / theme.QtySelector (theme.js). */
(function () {
  if (window.fmCartLoaded) return;
  window.fmCartLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function theme() {
    return window.theme || {};
  }

  /* ---------- remove: quantity 0 through the theme's quantity selector ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fm-remove]');
    if (!btn) return;
    e.preventDefault();

    var line = btn.closest('.fm-cart-line');
    var input = line && line.querySelector('.js-qty__num');
    if (!input) return;

    line.classList.add('is-removing');
    var giftKey = line.getAttribute('data-gift-key');
    // the gift wrap add-on shown inside this line goes first, then the line itself (it rebuilds the cart)
    (giftKey ? changeLine(giftKey, 0) : Promise.resolve()).then(function () {
      input.value = 0;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  function changeLine(key, quantity) {
    var routes = theme().routes || {};
    return fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).catch(function () {});
  }

  /* ---------- gift wrap add-on (fm-product.js): same quantity as its product line, gone without it ---------- */

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !cart.items) return;

    var parents = {};
    cart.items.forEach(function (item) {
      var id = item.properties && item.properties._gift_id;
      if (id) parents[id] = (parents[id] || 0) + item.quantity;
    });

    var updates = {};
    var changed = false;
    cart.items.forEach(function (item) {
      var link = item.properties && item.properties._gift_for;
      if (!link) return;
      var wanted = parents[link] || 0;
      if (item.quantity !== wanted) {
        updates[item.key] = wanted;
        changed = true;
      }
    });
    if (!changed) return;

    fetch(((theme().routes || {}).cartChange || '/cart/change.js').replace(/change\.js$/, 'update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .catch(function () {})
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
  });

  /* ---------- drawer sits right under the header on desktop ---------- */

  function placeDrawer() {
    var drawer = document.querySelector('[data-fm-cart-drawer]');
    if (!drawer) return;
    var header = document.querySelector('#SiteHeader') || document.querySelector('.site-header');
    var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    drawer.style.setProperty('--fm-drawer-top', top + 'px');
  }

  document.addEventListener('drawerOpen.CartDrawer', placeDrawer);
  document.addEventListener('ajaxProduct:added', placeDrawer);

  /* ---------- quick add (product cards) ---------- */

  // optional quantity field next to the button ("Pairs well with" cards)
  function quickAddQty(btn) {
    var scope = btn.closest('[data-fm-qty-scope]');
    var input = scope && scope.querySelector('[data-fm-qty]');
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fm-quick-add]');
    if (!btn) return;
    e.preventDefault();

    var t = theme();
    if (!t.routes || btn.classList.contains('is-loading')) return;

    var label = btn.textContent;
    btn.classList.add('is-loading');

    fetch(t.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-fm-quick-add'), 10), quantity: quickAddQty(btn) }] })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw json;
          return json;
        });
      })
      .then(function (json) {
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = label;
        }, 1800);

        if (document.querySelector('[data-fm-cart-drawer]') && !document.body.classList.contains('template-cart')) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: json } }));
        } else {
          // cart page: rebuild the items table and the summary
          document.dispatchEvent(new CustomEvent('cart:build'));
        }
      })
      .catch(function (err) {
        btn.textContent = (err && err.description) || label;
        setTimeout(function () { btn.textContent = label; }, 2500);
      })
      .then(function () {
        btn.classList.remove('is-loading');
      });
  });

  /* ---------- checkout offers (sections/fm-upsell.liquid): pop-ups before checkout, one offer after another ---------- */

  var upsellBypass = false;
  var upsellBtn = null;
  var upsellQueue = [];
  var upsellAccepted = false;

  function upsellEl() {
    return document.querySelector('[data-fm-upsell]');
  }

  function goCheckout() {
    // straight to checkout after adding: re-posting the cart form would send the old updates[] quantities
    if (upsellAccepted) {
      window.location.href = '/checkout';
      return;
    }
    // the button's own form submit keeps the theme's terms check and cart note
    if (upsellBtn && upsellBtn.form) {
      upsellBypass = true;
      upsellBtn.click();
      upsellBypass = false;
    } else {
      window.location.href = '/checkout';
    }
  }

  function showOffer(card) {
    var el = upsellEl();
    el.querySelectorAll('[data-fm-upsell-offer]').forEach(function (c) { c.hidden = c !== card; });
    card.querySelector('[data-fm-upsell-error]').hidden = true;
    card.querySelector('[data-fm-upsell-accept]').classList.remove('btn--loading');
    upsellQty(card, 1);
    if (card.querySelector('[data-fm-upsell-option]')) updateUpsellVariant(card);
    el.hidden = false;
    document.documentElement.classList.add('fm-upsell-open');
    card.querySelector('[data-fm-upsell-accept]').focus();
  }

  function hideUpsell() {
    var el = upsellEl();
    if (!el) return;
    el.hidden = true;
    document.documentElement.classList.remove('fm-upsell-open');
  }

  // next offer, or checkout after the last one
  function nextOffer() {
    var card = upsellQueue.shift();
    if (card) {
      showOffer(card);
      return;
    }
    hideUpsell();
    if (upsellBtn) upsellBtn.classList.remove('btn--loading');
    goCheckout();
  }

  function closeUpsell() {
    hideUpsell();
    upsellQueue = [];
    if (upsellBtn) {
      upsellBtn.classList.remove('btn--loading');
      upsellBtn.focus();
    }
    // an accepted offer is in the cart now: rebuild the drawer / page
    if (upsellAccepted) {
      upsellAccepted = false;
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: {} } }));
      }
    }
  }

  document.addEventListener('click', function (e) {
    if (upsellBypass) return;
    var btn = e.target.closest && e.target.closest('.cart__checkout');
    var el = upsellEl();
    if (!btn || !el || !btn.form) return;

    e.preventDefault();
    e.stopPropagation();
    upsellBtn = btn;
    upsellAccepted = false;
    if (btn.classList.contains('btn--loading')) return;
    btn.classList.add('btn--loading');

    fetch((theme().routes || {}).cart || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var inCart = (cart.items || []).map(function (item) { return item.product_id; });
        upsellQueue = cart.item_count ? Array.prototype.filter.call(el.querySelectorAll('[data-fm-upsell-offer]'), function (card) {
          return inCart.indexOf(parseInt(card.getAttribute('data-fm-upsell-product'), 10)) === -1;
        }) : [];
        nextOffer();
      })
      .catch(function () {
        btn.classList.remove('btn--loading');
        goCheckout();
      });
  }, true);

  // offers with variants: option dropdowns or pills (block setting) pick the variant (nothing preselected), price / image follow it
  function upsellVariants(card) {
    if (!card.fmVariants) {
      var json = card.querySelector('[data-fm-upsell-variants]');
      card.fmVariants = json ? JSON.parse(json.textContent) : [];
    }
    return card.fmVariants;
  }

  // one .fm-upsell__option per product option: a <select> or radio pills
  function upsellOptionValue(set) {
    var select = set.querySelector('select');
    if (select) return select.value || null;
    var checked = set.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  function upsellSelected(card) {
    return Array.prototype.map.call(card.querySelectorAll('.fm-upsell__option'), upsellOptionValue);
  }

  function updateUpsellVariant(card) {
    var variants = upsellVariants(card);
    var selected = upsellSelected(card);

    // values without any available variant (given the other choices) are crossed out (pills) / marked sold out (dropdown); still selectable
    card.querySelectorAll('.fm-upsell__option').forEach(function (set, index) {
      var choices = set.querySelector('select') ? set.querySelectorAll('option[value]:not([value=""])') : set.querySelectorAll('input');
      choices.forEach(function (choice) {
        var possible = variants.some(function (v) {
          return v.available && v.options[index] === choice.value && v.options.every(function (value, i) {
            return i === index || selected[i] === null || selected[i] === value;
          });
        });
        if (choice.tagName === 'OPTION') choice.textContent = possible ? choice.value : choice.value + ' (sold out)';
        else choice.parentNode.classList.toggle('is-unavailable', !possible);
      });
    });

    var variant = null;
    if (selected.indexOf(null) === -1) {
      variant = variants.filter(function (v) {
        return v.options.every(function (value, i) { return value === selected[i]; });
      })[0] || null;
    }
    card.setAttribute('data-fm-upsell-offer', variant && variant.available ? variant.id : '');
    card.querySelector('[data-fm-upsell-error]').hidden = true;
    if (!variant) return;

    var price = card.querySelector('[data-fm-upsell-price]');
    price.innerHTML = (variant.compare ? '<s></s>' : '') + '<b></b>';
    if (variant.compare) price.querySelector('s').textContent = variant.compare;
    price.querySelector('b').textContent = variant.price;

    var unit = card.querySelector('[data-fm-upsell-unit]');
    if (unit) {
      unit.textContent = variant.unit || '';
      unit.hidden = !variant.unit;
    }

    var img = card.querySelector('[data-fm-upsell-media] img');
    if (img && variant.image) {
      img.removeAttribute('srcset');
      img.src = variant.image;
    }

    if (!variant.available) upsellError(card, 'This option is sold out.');
  }

  function upsellError(card, text) {
    var msg = card.querySelector('[data-fm-upsell-error]');
    msg.textContent = text;
    msg.hidden = false;
  }

  // quantity picker: whole number 1–99; minus is disabled at 1
  function upsellQty(card, value) {
    var input = card.querySelector('[data-fm-upsell-qty-num]');
    if (!input) return 1;
    if (value === undefined) value = input.value;
    var qty = Math.min(Math.max(parseInt(value, 10) || 1, 1), 99);
    input.value = qty;
    card.querySelector('[data-fm-upsell-qty-step="-1"]').disabled = qty <= 1;
    return qty;
  }

  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('[data-fm-upsell-offer]');
    if (!card) return;
    if (e.target.hasAttribute('data-fm-upsell-option')) updateUpsellVariant(card);
    if (e.target.hasAttribute('data-fm-upsell-qty-num')) upsellQty(card);
  });

  document.addEventListener('click', function (e) {
    var el = upsellEl();
    if (!el || el.hidden || !e.target.closest) return;

    if (e.target.closest('[data-fm-upsell-close]')) {
      closeUpsell();
      return;
    }

    if (e.target.closest('[data-fm-upsell-decline]')) {
      nextOffer();
      return;
    }

    var step = e.target.closest('[data-fm-upsell-qty-step]');
    if (step) {
      var stepCard = step.closest('[data-fm-upsell-offer]');
      upsellQty(stepCard, upsellQty(stepCard) + parseInt(step.getAttribute('data-fm-upsell-qty-step'), 10));
      return;
    }

    var accept = e.target.closest('[data-fm-upsell-accept]');
    if (!accept || accept.classList.contains('btn--loading')) return;
    var card = accept.closest('[data-fm-upsell-offer]');
    if (!card.getAttribute('data-fm-upsell-offer')) {
      var missing = Array.prototype.filter.call(card.querySelectorAll('.fm-upsell__option'), function (set) {
        return !upsellOptionValue(set);
      })[0];
      if (missing) {
        upsellError(card, 'Please choose ' + missing.querySelector('legend, label').textContent.trim().toLowerCase() + '.');
        missing.querySelector('[data-fm-upsell-option]').focus();
      } else {
        upsellError(card, 'This option is sold out.');
      }
      return;
    }
    accept.classList.add('btn--loading');

    fetch((theme().routes || {}).cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(card.getAttribute('data-fm-upsell-offer'), 10), quantity: upsellQty(card) }] })
    })
      .then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw json;
          upsellAccepted = true;
          nextOffer();
        });
      })
      .catch(function (err) {
        accept.classList.remove('btn--loading');
        upsellError(card, (err && err.description) || 'Could not add the offer. Please try again.');
      });
  });

  document.addEventListener('keydown', function (e) {
    var el = upsellEl();
    if (e.key === 'Escape' && el && !el.hidden) closeUpsell();
  });

  // theme editor: selecting an offer block shows its pop-up
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-fm-upsell-offer]');
    if (card) showOffer(card);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    if (e.target.closest && e.target.closest('[data-fm-upsell-offer]')) hideUpsell();
  });

  /* ---------- paged slider: one dot per screen of cards ---------- */

  function initPager(track) {
    if (track.fmPager) return;
    track.fmPager = true;

    var root = track.parentNode;
    var dotsEl = root.querySelector('[data-fm-pager-dots]');
    if (!dotsEl) return;
    var ticking = false;

    function pages() {
      return Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
    }

    function current() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return 0;
      return Math.round((track.scrollLeft / max) * (pages() - 1));
    }

    function render() {
      var count = pages();
      dotsEl.hidden = count < 2;
      if (dotsEl.children.length !== count) {
        dotsEl.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'fm-dot';
          dot.setAttribute('aria-label', (i + 1) + ' / ' + count);
          dot.setAttribute('data-page', i);
          dotsEl.appendChild(dot);
        }
      }
      var active = current();
      Array.prototype.forEach.call(dotsEl.children, function (dot, i) {
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }

    dotsEl.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-page]');
      if (!dot) return;
      var page = parseInt(dot.getAttribute('data-page'), 10);
      var max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: Math.round(max * page / Math.max(1, pages() - 1)), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        render();
      });
    }, { passive: true });

    window.addEventListener('resize', render);
    render();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-fm-pager]').forEach(initPager);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
